// Main logo for white mode
import mainLogoW from '../assets/images/next-logo-white.svg';
// Sidebar menu icons for white mode
import adminWF from '../assets/images/icons/white/icon-admin-fill.svg';
import adminWL from '../assets/images/icons/white/icon-admin-line.svg';
import apisWF from '../assets/images/icons/white/icon-api-fill.svg';
import apisWL from '../assets/images/icons/white/icon-apis.svg';
import applicationWF from '../assets/images/icons/white/icon-application-fill.svg';
import applicationWL from '../assets/images/icons/white/icon-application-line.svg';
import clientsWF from '../assets/images/icons/white/icon-clients-fill.svg';
import clientsWL from '../assets/images/icons/white/icon-clients.svg';
import dashboardWF from '../assets/images/icons/white/icon-dashboard-fill.svg';
import dashboardWL from '../assets/images/icons/white/icon-dashboard.svg';
import documentationWF from '../assets/images/icons/white/icon-documentations-fill.svg';
import documentationWL from '../assets/images/icons/white/icon-documentations.svg';
import billingWF from '../assets/images/icons/white/icon-invoice-fill.svg';
import billingWL from '../assets/images/icons/white/icon-invoice-line.svg';
import logsWF from '../assets/images/icons/white/icon-logs-fill.svg';
import logsWL from '../assets/images/icons/white/icon-logs.svg';
import reportsWF from '../assets/images/icons/white/icon-reports-fill.svg';
import reportsWL from '../assets/images/icons/white/icon-reports.svg';
import serviceWF from '../assets/images/icons/white/icon-service-fill.svg';
import serviceWL from '../assets/images/icons/white/icon-service-line.svg';
import settingsWF from '../assets/images/icons/white/icon-settings-fill.svg';
import settingsWL from '../assets/images/icons/white/icon-settings.svg';
import supportWF from '../assets/images/icons/white/icon-support-fill.svg';
import supportWL from '../assets/images/icons/white/icon-support-line.svg';
// Any Type icons
import defaultAvatar from '../assets/images/icons/default-avatar.jpg';
// All icon for white mode
import downArrowV2W from '../assets/images/icons/white/icon-angle-down-v2.svg';
import bellDotW from '../assets/images/icons/white/icon-bell-dot.svg';
import calendarW from '../assets/images/icons/white/icon-calendar-fill.svg';
import emailW from '../assets/images/icons/white/icon-email-bg.svg';
import locationW from '../assets/images/icons/white/icon-location-bg.svg';
import plusW from '../assets/images/icons/white/icon-plus.svg';
import syncW from '../assets/images/icons/white/icon-sync-fill.svg';
import telephoneW from '../assets/images/icons/white/icon-telephone-bg.svg';
// Action icons for white mode
import accessWF from '../assets/images/icons/white/icon-access-fill.svg';
import accessWL from '../assets/images/icons/white/icon-access-line.svg';
import agency from '../assets/images/icons/white/icon-agency.svg';
import leftArrowLW from '../assets/images/icons/white/icon-arrow-left.svg';
import barsW from '../assets/images/icons/white/icon-bars.svg';
import bellW from '../assets/images/icons/white/icon-bell.svg';
import copyIconWL from '../assets/images/icons/white/icon-copy-v1-line.svg';
import customer from '../assets/images/icons/white/icon-customer.svg';
import distributor from '../assets/images/icons/white/icon-distributor.svg';
import endoscopyW from '../assets/images/icons/white/icon-endoscopy.svg';
import loadingW from '../assets/images/icons/white/icon-loading.svg';
import manageBtnWF from '../assets/images/icons/white/icon-manage-file.svg';
import manageBtnWL from '../assets/images/icons/white/icon-manage-line.svg';
import optionBtnWF from '../assets/images/icons/white/icon-option-fill.svg';
import optionBtnWL from '../assets/images/icons/white/icon-option-line.svg';
import reloadWF from '../assets/images/icons/white/icon-reload-fill.svg';
import reloadWL from '../assets/images/icons/white/icon-reload-line.svg';
import reseller from '../assets/images/icons/white/icon-reseller.svg';
import rightArrowLW from '../assets/images/icons/white/icon-right-arrow-line.svg';
import searchWv2 from '../assets/images/icons/white/icon-search-v2.svg';
import searchW from '../assets/images/icons/white/icon-search.svg';
import sortingArrowW from '../assets/images/icons/white/icon-sorting-table-arrow.svg';
import sunW from '../assets/images/icons/white/icon-sun.svg';
import tickIconWL from '../assets/images/icons/white/icon-tick-line.svg';
// Action icons for dark mode
import moonD from '../assets/images/icons/dark/icon-moon.svg';

// Main logos
export const logo = {
    // This log for white mode
    mainLogoW
};

// Sidebar icons
export const menuIcon = {
    // this icons for white mode
    dashboardWL,
    clientsWL,
    logsWL,
    reportsWL,
    apisWL,
    settingsWL,
    documentationWL,
    apisWF,
    clientsWF,
    dashboardWF,
    documentationWF,
    supportWF,
    supportWL,
    adminWF,
    adminWL,
    billingWF,
    billingWL,
    logsWF,
    reportsWF,
    settingsWF,
    applicationWL,
    applicationWF,
    serviceWL,
    serviceWF
};

// Action icons
export const actionIcons = {
    // White Mode Icons
    barsW,
    sunW,
    bellW,
    searchW,
    searchWv2,
    sortingArrowW,
    accessWL,
    accessWF,
    optionBtnWL,
    optionBtnWF,
    manageBtnWL,
    manageBtnWF,
    reloadWF,
    reloadWL,
    loadingW,
    tickIconWL,
    copyIconWL,

    // Dark Mode icons
    moonD
};

export const icons = {
    defaultAvatar,

    // Any Type icon for white mode
    bellDotW,
    plusW,
    endoscopyW,
    rightArrowLW,
    leftArrowLW,
    telephoneW,
    emailW,
    locationW,
    syncW,
    calendarW,
    downArrowV2W,

    // role
    customer,
    distributor,
    agency,
    reseller
};

export default null;
